import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
              <i className="ri-film-line text-xl text-background-50"></i>
            </div>
            <span className="text-lg font-semibold text-foreground-950 font-[var(--font-heading)]">
              6080新视觉影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-accent-600 bg-accent-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {movieCategories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-accent-600 bg-accent-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-accent-600 bg-accent-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50 py-3">
            <Link
              to="/"
              className={`block px-4 py-2.5 rounded-md text-sm font-medium transition-colors ${
                location.pathname === '/'
                  ? 'text-accent-600 bg-accent-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {movieCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`block px-4 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-accent-600 bg-accent-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block px-4 py-2.5 rounded-md text-sm font-medium transition-colors ${
                location.pathname === '/about'
                  ? 'text-accent-600 bg-accent-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}